require('intersection-observer');
import merchPod_carousel from "./merchPodCarousel";
import lazy_loading from "./lazyLoading";
